/** @format */
import React from 'react';
import { createRoot } from 'react-dom/client';
import Header from './header';

/**
 * Build Header.
 */
export const header = (): void => {
  const header: HTMLElement | null = document.getElementById('varian-header');
  if (header !== null) {
    const root = createRoot(header);
    root.render(<Header />);
  }
};
